module.exports = __webpack_public_path__ + "img/sFwdHB.4b3da65e.svg";